<template>
  <div class="consult-container">
    <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
    <div class="search-container">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="应用名称">
          <el-input v-model="formInline.appName" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item label="服务名称">
          <el-input v-model="formInline.serveName" placeholder="请输入服务名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{ (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="memberName" label="用户" align="center">
        </el-table-column>
        <el-table-column prop="createDate" label="申请时间" align="center" :formatter="dateFormat">
        </el-table-column>
        <el-table-column prop="appName" align="center" label="应用名称">
        </el-table-column>
        <el-table-column prop="serverName" align="center" label="服务名称">
        </el-table-column>
        <el-table-column prop="remark" align="center" label="描述">
        </el-table-column>
        <el-table-column prop="serverStatus" align="center" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.serverStatus === 1">审核中</span>
            <span v-else-if="scope.row.serverStatus === 2">审核未通过</span>
            <span v-else-if="scope.row.serverStatus === 3">（使用中）审核通过</span>
            <span v-else-if="scope.row.serverStatus === 4">已终止</span>
            <span v-else>未知状态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button v-if="scope.row.serverStatus === 1" type="text" size="small" class="ml-10"
              @click="handleReviewClick(scope.row)">审核</el-button>
            <el-popconfirm title="确定要中止吗？" @confirm="handleStopClick(scope.row, 4)">
              <el-button slot="reference" class="ml-10" v-if="scope.row.serverStatus === 3" type="text"
                size="small">中止</el-button>
            </el-popconfirm>
            <el-popconfirm title="确定要启用吗？" @confirm="handleStopClick(scope.row, 3)">
              <el-button slot="reference" class="ml-10" v-if="scope.row.serverStatus === 4" type="text"
                size="small">启用</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>
    <!-- 审核功能 -->
    <el-drawer title="审核" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
      <el-form ref="form" :model="drawerForm" label-width="120px">
        <el-form-item label="实际到账金额">
          <el-input v-model="drawerForm.price" placeholder="请输入实际到账金额"></el-input>
        </el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="drawerForm.result">
            <el-radio :label="0">通过</el-radio>
            <el-radio :label="1">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="drawerForm.result === 1">
          <el-input type="textarea" v-model="drawerForm.reason" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="submitReview" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getServiceList, getServiceStop } from '@/api/resourcesManagement'
import { getResourceReview } from '@/api/operationsManagement'
import moment from 'moment'
import ComDetail from '@/components/common/comDetail.vue';
export default {
  name: 'AdminStaticsResourceApplication',
  components: {
    ComDetail
  },
  data() {
    return {
      tableLoading: false,
      drawer: false,
      detail: {
        visible: false,
        record: {},
      },
      detailCols: [
        {
          label: '用户',
          prop: 'memberName'
        },
        {
          label: '申请时间',
          prop: 'createDate',
          formatter: (row) => moment(row.createDate).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          label: '应用名称',
          prop: 'appName'
        },
        {
          label: '服务名称',
          prop: 'serverName'
        },
        {
          label: '描述',
          prop: 'remark'
        },
      ],
      formInline: {
        appName: '',
        serveName: ''
      },
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: 'total, prev, pager, next, jumper', // 分页布局
      },
      tableData: [],
      drawerForm: {
        result: 0,
        reason: '',
        price: '',
      },
      record: {}
    };
  },

  mounted() {
    this.loadData()
  },
  methods: {
    // 查看
    onCancel() {
      this.detail.visible = false
    },
    cancelForm() {
      this.drawer = false
    },
    // 时间转换
    dateFormat(row) {
      return moment(row.askDate).format('YYYY-MM-DD HH:mm:ss');
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleClick(row) {
      this.detail.visible = true
      this.detail.record = row
    },
    handleReviewClick(row) {
      this.drawer = true
      this.record = row
    },
    // 审核-确定
    async submitReview() {
      const params = {
        memberId: this.record.memberId,
        result: this.drawerForm.result,
        appServerId: this.record.id,
        reviewType: 6,
        receiveMoney: Number(this.drawerForm.price)
      }
      if (this.drawerForm.result === 1) {
        params.reason = this.drawerForm.reason
      }
      await getResourceReview({
        ...params
      }).then(() => {
        this.$message.success('审核成功')
        this.drawer = false
        this.record = {}
        this.loadData()
      })
    },
    onSubmit() {
      this.loadData()
    },
    // 启用/中止
    handleStopClick(row, status) {
      getServiceStop({
        id: row.id,
        status, // 3 启用 4 停止
      }).then(() => {
        this.$message.success(`${status === 3 ? '启用' : '停止'}成功`)
        this.loadData()
      })
    },
    async loadData() {
      this.tableLoading = true
      const params = {}
      if (this.formInline.appName) {
        params.appName = this.formInline.appName
      }
      if (this.formInline.serveName) {
        params.serveName = this.formInline.serveName
      }
      await getServiceList({
        pageNo: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
        ...params,
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.content
        this.pagination.total = res.data.totalElements
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.consult-container {
  background: #fff;
  padding: 24px 0;

  .search-container {
    padding: 0 16px;
    border-bottom: 1px solid #EBEEF5;
  }

  .table-container {
    padding: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }

  .ml-10 {
    margin: 0 10px;
  }

  .drawer-footer {
    text-align: center;
  }
}

::v-deep .el-drawer__body {
  padding: 0 16px;
}
</style>
<style lang="scss">
.el-popconfirm__main {
  margin: 10px 0;
}
</style>